import { types } from 'mobx-state-tree';

export const Integration = types.model({
  id: types.identifierNumber,
  name: types.maybeNull(types.string),
  // metadata: null,
  display_name: types.maybeNull(types.string),
  archived: types.boolean,
  // 'cloud' for integrations we pull from remotely with saved credentials; anything else
  // (cli, mssql, file, ...) is a local integration with nothing to connect to from here.
  pos_type: types.maybeNull(types.string),
});
